export default __webpack_public_path__ + "static/media/cert-ngo-cpttm.97523745.jpg";